import WebRoutes from './Routes.jsx';

export default WebRoutes;